import React, { useState } from 'react';
import { Button, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, FormGroup } from 'reactstrap';
import { Cosmetic, CreateCosmetic } from '../../models/Cosmetic';
import { cosmeticService } from '../../services/cosmeticService';

type Props = {
    toggle: boolean;
    setToggle: Function;
    cosmetic: Cosmetic;
    setCosmetic: Function;
    name: string;
    brand: string;
    category: string;
    type: string;
};

const CreateShortModal = ({ name, brand, category, type, toggle, setToggle, cosmetic, setCosmetic }: Props) => {

    const [color, setColor] = useState<string>('');
    const [grade, setGrade] = useState<number>(1);
    const [comment, setComment] = useState<string>('');

    const [invalid, setInvalid] = useState<boolean>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const addReview = async () => {
        if (!comment || comment.length < 1) {
            setInvalid(true);
            return;
        }
        setIsLoading(true);
        let create: CreateCosmetic = {
            name: name,
            brand: brand,
            category: category,
            type: type,
            color: color.length < 1 ? 'default' : color,
            grade: grade,
            comment: comment,
            image: ''
        };
        try {
            const cosmetic = await cosmeticService.addReview(create);
            setCosmetic(cosmetic);
            setToggle(false);
            setIsLoading(false);
        }
        catch {
            alert("Problemy przepraszamy");
            setIsLoading(false);
        }
    }

    const cancel = async () => {
        setInvalid(undefined);
        setToggle(!toggle);
    }

    const notes = [1, 2, 3, 4, 5];

    return (
        <Modal isOpen={toggle} toggle={() => cancel()}>
            <Form>
                <ModalHeader toggle={() => cancel()}>Dodaj komentarz</ModalHeader>
                <ModalBody>
                    Odcień (opcjonalnie)
                <Input type="text" onChange={(e) => setColor(e.target.value)} />
                Ocena
                <div>
                        {notes.map(note =>
                            (<FormGroup key={note} check inline><Label><Input type="radio" name="note" value={note} onChange={(e) => setGrade(parseInt(e.target.value))} />
                                {note}</Label> </FormGroup>))}
                    </div>
                 Komentarz <span style={{ color: 'red' }}>*</span>
                    <Input invalid={invalid && !comment} type="textarea" onChange={(e) => setComment(e.target.value)} />
                </ModalBody>
                <ModalFooter>
                    {invalid && !comment && <div style={{ color: 'red' }}>Komentarz jest wymagany</div>}
                    {isLoading ?
                        <div className="spinner" /> :
                        <>
                            <Button className="single-btn" color="primary" onClick={() => addReview()}>Dodaj</Button>{' '}
                            <Button color="secondary" onClick={() => cancel()}>Anuluj</Button>
                        </>}
                </ModalFooter>
            </Form>
        </Modal>
    );
}

export default CreateShortModal;
